export const ActionTypes = {
  FETCH_ALL: 'services/downtimeReason/fetch_all',
  FETCH_DOWNTIME_CATEGORIES: 'services/downtimeReason/fetch_downtime_categories',
  FETCH_DOWNTIME_REASON_BY_CATEGORYID: 'services/downtimeReason/fetch_downtime_reason_categoryid',
  SET_ALL_DOWNTIME_CATEGORIES: 'services/downtimeReason/set_all_downtime_categories',
  SET_ALL_DOWNTIME_CATEGORIES_REASON: 'services/downtimeReason/set_all_downtime_categories_reasons',
  SET_LOADER_STATUS: 'services/downtimeReason/set_loader_status',
  SET_ALL: 'services/downtimeReason/set_all',
  ADD_OR_UPDATE_DOWNTIME_REASON: 'services/downtimeReason/add_or_update_downtime_reason',
  DELETE_DOWNTIME_REASON: 'services/downtimeReason/delete_downtime_reason',
  FETCH_ALL_DOWNTIME_REASON: 'services/downtimeReason/fetch_all_downtime_reason',
  SET_ALL_DOWNTIME_REASON: 'services/downtimeReason/set_all_downtime_reason',
};
const fetchAllDowntimeReason = () => ({
  type: ActionTypes.FETCH_ALL_DOWNTIME_REASON,
});

const setAllDowntimeReason = ({ allDowntimeReasonData }) => ({
  allDowntimeReasonData,
  type: ActionTypes.SET_ALL_DOWNTIME_REASON,
});

const fetchAll = ({ downtimeReasonParams }) => ({
  downtimeReasonParams,
  type: ActionTypes.FETCH_ALL,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const fetchDowntimeCategories = () => ({
  type: ActionTypes.FETCH_DOWNTIME_CATEGORIES,
});

const fetchDowntimeReasonByCategoryId = ({ downtimeCategoryId }) => ({
  downtimeCategoryId,
  type: ActionTypes.FETCH_DOWNTIME_REASON_BY_CATEGORYID,
});

const setAllDowntimeCategories = ({ downtimeCategories }) => ({
  downtimeCategories,
  type: ActionTypes.SET_ALL_DOWNTIME_CATEGORIES,
});

const setAllDowntimeCategoriesReason = ({ downtimeCategoryReasons }) => ({
  downtimeCategoryReasons,
  type: ActionTypes.SET_ALL_DOWNTIME_CATEGORIES_REASON,
});

const setAll = ({ allDowntime }) => ({
  allDowntime,
  type: ActionTypes.SET_ALL,
});
const addorUpdateDowntimeReason = ({ downtimeReasonData, actionName, downtimeReasonParams }) => ({
  downtimeReasonData,
  actionName,
  downtimeReasonParams,
  type: ActionTypes.ADD_OR_UPDATE_DOWNTIME_REASON,
});

const deleteDowntimeReason = ({ id, downtimeReasonParams }) => ({
  id,
  downtimeReasonParams,
  type: ActionTypes.DELETE_DOWNTIME_REASON,
});

export default {
  fetchAll,
  setAll,
  fetchDowntimeCategories,
  fetchDowntimeReasonByCategoryId,
  setAllDowntimeCategoriesReason,
  setAllDowntimeCategories,
  setLoader,
  addorUpdateDowntimeReason,
  deleteDowntimeReason,
  fetchAllDowntimeReason,
  setAllDowntimeReason,
};
